import type { ElementType, HTMLAttributes } from 'react';

import { cn } from '@/lib/cn';

const WIDTHS = {
  sm: 'max-w-3xl',
  md: 'max-w-5xl',
  lg: 'max-w-7xl',
  full: 'max-w-none',
} as const;

interface ContainerProps extends HTMLAttributes<HTMLElement> {
  as?: ElementType;
  size?: keyof typeof WIDTHS;
}

/**
 * The single horizontal rhythm of the site. Every section uses it, so gutters
 * and max-widths stay identical from the header to the footer.
 */
export function Container({ as: Tag = 'div', size = 'lg', className, ...props }: ContainerProps) {
  return <Tag className={cn('mx-auto w-full px-4 sm:px-6', WIDTHS[size], className)} {...props} />;
}
